import { Form } from '@bancobarigui/barihaus';

import { InspectorUserForm } from './InspectorRegisterForm';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';
import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { LoadingOverlay } from '@/components/LoadingOverlay';
import { ServiceCheck, FeatureAlert } from '@/shared/components';

import { useInspectorUserRegister } from './useInspectorUserRegister';

function InspectorUserRegisterContent() {
  const { onSubmit, isSubmitting } = useInspectorUserRegister();

  return (
    <>
      <LoadingOverlay visible={isSubmitting} tip="Cadastrando inspetor..." />

      <Form className="space-y-8" name="basic" onFinish={onSubmit}>
        <InspectorUserForm />

        <RegisterFormButtons onClickCancel={() => {}} loading={isSubmitting} />
      </Form>
    </>
  );
}

export default function InspectorUserRegister() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Cadastrar novo usuário - Módulo Inspetor" />}
    >
      <FeatureAlert services={['user']} />
      <ServiceCheck services={['user']} featureName="Cadastro de Inspetor">
        <InspectorUserRegisterContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
